module.exports = __webpack_public_path__ + "static/media/icon09.7f06a9f8.svg";